export function cta(className, imageBg, subheadline, headline, text, link, linkText) {
  // prettier-ignore
  const ctaSection = `
    <div class="cta ` + className + `">
      <div class="cta__container ` + className + `" style="background: url('/user/documents/img/` + imageBg + `')">
        <div class="cta__text">
          <div class="cta__subhealine subheadline">
            `+ subheadline + `
          </div>
          <div class="cta__headline h1">
            `+ headline + `
          </div>
          <div class="cta__textfield">
            `+ text + `
          </div>
          <a class="btn btn--arrow-right" href="`+ link + `" target="_blank">`+ linkText + `</a>
        </div>
      </div>
    </div>
  `;
  return ctaSection;
}
